// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore} from "firebase/firestore"
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage"
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCD5sHbw1Znpfelh1FBILYnRPbScPXbKDw",
  authDomain: "rad-venture.firebaseapp.com",
  projectId: "rad-venture",
  storageBucket: "rad-venture.appspot.com",
  messagingSenderId: "185288165769",
  appId: "1:185288165769:web:29b3e290d2cef7c70bb958",
  measurementId: "G-J1K24NXPZF"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app)


export const storage = getStorage(app)
// const analytics = getAnalytics(app);
const firestore = getFirestore(app)

export {firestore, app as default}